export default __webpack_public_path__ + "assets/webgl/perlin.e6977706.jpg";